<template>
  
    <b-icon :icon="icon" class="icon-box"></b-icon>
  
</template>

<script>
export default {
  name: "Ic1",
  props: ["icon"],
};
</script>

<style scoped>
.icon-box{
    margin-left: 10px;
    width: 60px;
    height: 60px;
    padding: 15px;
    background-color:var(--light-primary);
    border-radius: 50%;
    border: 1px solid var(--light-secondary);
    color: var(--light);
    box-shadow: 5px 5px 1px var(--light-secondary);
}



</style>